import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import { Box } from './Styles'

const Modal = ({ open, title, maxWidth, children, onClose, closeLabel, onSubmit, submitLabel, submitDisabled, isLoading, afterContent, rightTitleContent }) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      {title && !rightTitleContent && (
        <DialogTitle>{title}</DialogTitle>
      )}
      {title && rightTitleContent && (
        <DialogTitle>
          <Box direction='row' align='center' justify='space-between'>
            <div>{title}</div>
            {rightTitleContent}
          </Box>
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
      {afterContent}
      {(onClose || onSubmit) && (
        <DialogActions>
          {onClose && (
            <Button onClick={onClose} color="primary">
              {closeLabel || t('common:buttons.Close')}
            </Button>
          )}
          {(onSubmit) && (
            <LoadingButton onClick={onSubmit} color="primary" disabled={submitDisabled} loading={isLoading}>
              {submitLabel || t('common:buttons.Save')}
            </LoadingButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  )
}

Modal.defaultProps = {
  open: true,
  maxWidth: 'lg',
  submitDisabled: false,
  isLoading: false,
  afterContent: null,
  rightTitleContent: null,
}

Modal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.any,
  rightTitleContent: PropTypes.any,
  maxWidth: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  afterContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClose: PropTypes.func,
  closeLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  submitLabel: PropTypes.string,
  submitDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
}

export default Modal
